module.exports = __webpack_public_path__ + "media/images/blobs/blob-red-eeff80f1e1e2385893f085bef15ec280.svg";